import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import MultivarStats from './MultivarStats';
import { H2 } from '@blueprintjs/core';

class Multivar extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:'specOcc',
    calcRes:{}
  }

  componentDidMount() {
    this.fetchCalcRes(this.props.sessionId);
  }


  fetchCalcRes = (sessionId) => {
    const endpoint = process.env.REACT_APP_API_BASE +'/sessions/'+sessionId+'/calc_res-params.json';
    
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        this.setState({ calcRes: data });
      });
    })
  }


  calcData = (sessionId,dataType)=> {
    var links={};
    if (this.state.calcRes[dataType]) {
      if (this.state.calcRes[dataType].main && this.state.calcRes[dataType].main.MainTableWidget ) {
        links.main={};
        links.main.mainTable= process.env.REACT_APP_API_BASE+"/sessions/"+sessionId+"/"+dataType+"/main/"+this.state.calcRes[dataType].main.MainTableWidget;
      }

      if (this.state.calcRes[dataType].hclust && this.state.calcRes[dataType].hclust.success) {
        links.hclust={};
        links.hclust.plot=this.state.calcRes[dataType].hclust.plotWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
        links.hclust.distMat=this.state.calcRes[dataType].hclust.distMatWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pca && this.state.calcRes[dataType].pca.success) {
        links.pca={};
        links.pca.varPlot=this.state.calcRes[dataType].pca.var.plotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pca && this.state.calcRes[dataType].pca.success ) {
        links.pca.indPlot=this.state.calcRes[dataType].pca.ind.plotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pamk_mds && this.state.calcRes[dataType].pamk_mds.success) {
        links.mds={};
        links.mds.plot=this.state.calcRes[dataType].pamk_mds.plotWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
        links.mds.distMat=this.state.calcRes[dataType].pamk_mds.distMatWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].ca && this.state.calcRes[dataType].ca.success) {
        links.ca={};
        links.ca.plot=this.state.calcRes[dataType].ca.caPlotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].xtab && this.state.calcRes[dataType].xtab.success) {
        links.xtab={};
        links.xtab.main=process.env.REACT_APP_API_BASE+"/sessions/"+sessionId+"/"+dataType+"/xtab/"+this.state.calcRes[dataType].xtab.main.MainTableWidget;
      }

    }
    return links;
  };

  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });

  render() {
    const { t, sessionId } = this.props;

    const specOccLinks=this.calcData(sessionId,'spec_occ');
    console.log(specOccLinks);
    const specCoocLinks=this.calcData(sessionId,'spec_cooc');
    const assocCoocLinks=this.calcData(sessionId,'assoc_cooc');

    const specOccNotEmpty=Object.keys(specOccLinks).length>0;
    const specCoocNotEmpty=Object.keys(specCoocLinks).length>0;
    const assocCoocNotEmpty=Object.keys(assocCoocLinks).length>0;

    const specOcc =<MultivarStats urls={specOccLinks}  />;
    const specCooc =<MultivarStats urls={specCoocLinks}  />;
    const assocCooc =<MultivarStats urls={assocCoocLinks}  />;


    return (
      <>
        <H2>{t('multivarStats')}</H2>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          { specOccNotEmpty && <Tab id='specOcc' title={t('specOccStats')} panel={specOcc} /> }
          { specCoocNotEmpty && <Tab id='specCooc' title={t('specCoocStats')} panel={specCooc} /> }
          { assocCoocNotEmpty && <Tab id='assocCooc' title={t('assocCoocStats')} panel={assocCooc} /> }
        </Tabs>
      </>
    );
  }
}

Multivar.propTypes = {
   sessionId: PropTypes.string
};

export default withTranslation()(Multivar);
